export const BASE_MODELS = [
    { key: 'users', name: 'Usuarios', icon: '👤' },
    { key: 'clients', name: 'Clientes', icon: '👥' },
    { key: 'products', name: 'Productos', icon: '📦' },
    { key: 'productLines', name: 'Líneas de Producto', icon: '📋' },
    { key: 'invoices', name: 'Facturas', icon: '📄' },
    { key: 'turnos', name: 'Turnos', icon: '🕐' },
    { key: 'cajas', name: 'Cajas', icon: '💰' },
    { key: 'aperturaDeCaja', name: 'Aperturas de Caja', icon: '🔓' },
    { key: 'cierreDeCaja', name: 'Cierres de Caja', icon: '🔒' },
    { key: 'formasPago', name: 'Formas de Pago', icon: '💳' },
    { key: 'colegios', name: 'Colegios', icon: '🏫' },
    { key: 'tpvs', name: 'Tiendas', icon: '🏪' },
    { key: 'coupons', name: 'Cupones', icon: '🎫' },
    { key: 'campaigns', name: 'Campañas', icon: '📢' },
    { key: 'salesPrices', name: 'Precios de Venta', icon: '💰' },
    { key: 'empresa', name: 'Empresa', icon: '🏢' }
];